import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { XCircle, ShieldCheck, FileWarning, Scale, AlertOctagon, BadgeCheck } from 'lucide-react';
export function ProEliteExplainer() {
  return <section className="py-12 md:py-[70px] px-5 bg-navy text-white" data-id="element-175">
      <div className="max-w-[860px] mx-auto" data-id="element-176">
        <div className="text-[11px] font-extrabold tracking-[0.14em] uppercase text-gold mb-2" data-id="element-177">
          ¿Qué agrega DEFENDETE TOTAL?
        </div>
        <h2 className="font-display text-[clamp(24px,5vw,44px)] text-white mb-6 md:mb-9 leading-tight" data-id="element-178">
          Para quienes quieren la protección máxima
        </h2>

        <div className="space-y-5 md:space-y-6" data-id="element-179">
          {/* Tomo 7 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden" data-id="element-180">
            <div className="px-5 py-4 md:px-6 md:py-5 border-b border-white/10 flex items-center gap-3" data-id="element-181">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-gold/15 border border-gold/30 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-182">
                <FileWarning className="text-gold" size={22} strokeWidth={1.8} data-id="element-183" />
              </div>
              <h4 className="text-[14px] md:text-[17px] font-bold text-gold-light leading-tight" data-id="element-184">
                Tomo 7 — Los 30 errores que arruinan cualquier reclamo
              </h4>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 p-4 md:p-5" data-id="element-185">
              <ComparisonCard Icon={AlertOctagon} label="❌ Sin este tomo" text="Cometés errores de procedimiento sin saberlo y perdés reclamos que tenías ganados." variant="bad" data-id="element-186" />
              <ComparisonCard Icon={BadgeCheck} label="✅ Con este tomo" text="Sabés exactamente qué no hacer en cada etapa y checkeás tu reclamo antes de presentarlo." variant="good" data-id="element-187" />
            </div>
          </motion.div>

          {/* Tomo 8 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden" data-id="element-188">
            <div className="px-5 py-4 md:px-6 md:py-5 border-b border-white/10 flex items-center gap-3" data-id="element-189">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-gold/15 border border-gold/30 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-190">
                <Scale className="text-gold" size={22} strokeWidth={1.8} data-id="element-191" />
              </div>
              <h4 className="text-[14px] md:text-[17px] font-bold text-gold-light leading-tight" data-id="element-192">
                Tomo 8 — Cuándo sí necesitás un abogado y cómo elegir bien
              </h4>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 p-4 md:p-5" data-id="element-193">
              <ComparisonCard Icon={XCircle} label="❌ Sin este tomo" text="Contratás el primero que encontrás, pagás honorarios abusivos o no sabés cuándo realmente lo necesitás." variant="bad" data-id="element-194" />
              <ComparisonCard Icon={ShieldCheck} label="✅ Con este tomo" text="Sabés exactamente cuándo podés solo y cuándo conviene contratar un especialista, y cómo elegirlo sin que te estafen." variant="good" data-id="element-195" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}
interface ComparisonCardProps {
  Icon: ComponentType<{
    size?: number;
    strokeWidth?: number;
    className?: string;
  }>;
  label: string;
  text: string;
  variant: 'bad' | 'good';
}
function ComparisonCard({
  Icon,
  label,
  text,
  variant
}: ComparisonCardProps) {
  const isBad = variant === 'bad';
  return <div className={`rounded-xl p-4 md:p-5 border ${isBad ? 'bg-danger/10 border-danger/30' : 'bg-success/10 border-success/30'}`} data-id="element-196">
      {/* Big illustrative icon */}
      <div className="flex justify-center mb-3" data-id="element-197">
        <div className={`w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center ${isBad ? 'bg-danger/20' : 'bg-success/20'}`} data-id="element-198">
          <Icon size={36} strokeWidth={1.8} className={isBad ? 'text-[#E57373]' : 'text-[#66BB6A]'} data-id="element-199" />
        </div>
      </div>

      <strong className={`block text-[11px] md:text-[12px] font-extrabold tracking-[0.06em] uppercase mb-2 text-center ${isBad ? 'text-[#E57373]' : 'text-[#66BB6A]'}`} data-id="element-200">
        {label}
      </strong>
      <p className="text-[12px] md:text-[13px] text-white/80 text-center leading-snug" data-id="element-201">
        {text}
      </p>
    </div>;
}